/* Wohnel integration hooks: theme editor, cart semantics and theme-level brand details. */
(() => {
  const syncCartLabels = () => {
    document.querySelectorAll('.cart-link').forEach(link => {
      const count = Number(link.querySelector('.cart-link__count')?.textContent.trim() || 0);
      link.setAttribute('aria-label', `Warenkorb, ${count} ${count === 1 ? 'Artikel' : 'Artikel'}`);
    });
  };
  syncCartLabels();
  document.addEventListener('on:cart:after-merge', syncCartLabels);
  document.addEventListener('wohnel:header-cart-updated', syncCartLabels);
  document.addEventListener('shopify:section:load', syncCartLabels);
})();
